import React, {
  Component
} from 'react'
import styles from './Module.module.less'
import FocusSwiper from '../components/FocusSwiper'
import NavChanel from '../components/NavChanel'
import Tabs from '../components/Tabs'
import Stars from '../components/Stars'
import AdComponent from '../components/AdComponent'
import ChanelHeader from '../components/ChanelHeader'
import PackList from '../components/PackList'
import PackFocusList from '../components/PackFocusList'
import Carousel from '../components/Carousel'
import common from '../common/common.module.less'
import classNames from 'classnames'
if (__isBrowser__) {
  require('antd/lib/popover/style/index.css')
}
const htmlComponent = (data) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: data.htmlContent }} />
  )
}

/**
 * tab渲染
 */
const tabList = (data, tabType) => {
  return (
    <Tabs
      mainTitleLinks={data.mainTitleLinks}
      subRightLinkInfo={data.subRightLinkInfo}
      components={data.components}
      moduleId={data.moduleId}
      tabTitle={data.tabTitle.length === 0 ? [{ name: '' }] : data.tabTitle}
      tabType={data.tabType}
      spm={data.spm} />
  )
}

const packList = (data, changeIndex) => {
  const component = data.components[0]
  const trackInfo = component.trackInfo || {}
  return (
    <div data-spm={component.spm}
      data-name='c_pos'
      data-mname={trackInfo.drawer}
      data-cname={trackInfo.component_title}
      data-cid={trackInfo.component_id}
      data-mid={trackInfo.drawerid}
      data-trackinfo={JSON.stringify(trackInfo)}>
      {
        component.isFocus
          ? <PackFocusList
            list={component.itemList}
            isOneLineTitle={component.isOneLineTitle}
            isHorizontal={component.isHorizontal} />
          : <PackList list={component.itemList}
            isHorizontal={component.isHorizontal}
            rank={component.isRank}
            changeNum={data.changeNum}
            isOneLineTitle={component.isOneLineTitle}
            changeIndex={changeIndex}
            row={component.totalLine || 2} />
      }
    </div>
  )
}

export default class Module extends Component {
    staticProps = {
      moduleId: '',
      type: '',
      data: {}
    }
    constructor (props) {
      super(props)
      this.state = {
        changeIndex: 0
      }
    }
    changeHandle (e) {
      let changeIndex = this.state.changeIndex
      changeIndex = ++changeIndex % this.props.data.changeNum
      this.setState({ changeIndex: changeIndex })
    }
    renderContent (type, data) {
      let __html
      switch (type) {
        case 'PC_CAROUSEL':
          __html = <Carousel data={data} />
          break

        case 'PC_ADS':
          __html = <AdComponent data={data} />
          break

        case 'PC_HTML':
          __html = htmlComponent(data)
          break

        case 'PC_BANNER':
          __html = <FocusSwiper data={data} />
          break

        case 'WEB_NAV_SEC':
          __html = <ChanelHeader components={data.components} mainTitleLinks={data.mainTitleLinks} />
          break

        case 'PC_NAV':
          __html = <NavChanel data={data} />
          break

        case 'NORMAL':
          if (data.components && data.components.length > 0 && data.components[0].tag === 'WEB_PIC_LIST') {
            __html = <Stars component={data.components[0]} />
          } else {
            __html = packList(data, this.state.changeIndex)
          }
          break
        case 'PC_TILE_LIST':
          __html = packList(data, this.state.changeIndex)
          break
        case 'PC_TAB':
          __html = tabList(data, 'tab')
          break
        default:
          __html = packList(data, this.state.changeIndex)
      }
      return __html
    }

    renderHeader (type) {
      let {
        mainTitleLinks,
        subTitleLinks,
        subRightLinkInfo,
        tabType,
        changeNum
      } = this.props.data
      if (!mainTitleLinks || mainTitleLinks.length === 0 || (tabType !== 'TIME' && type !== 'NORMAL' && type !== 'PC_TILE_LIST')) {
        return ''
      }
      // subTitleLinks的处理需要重新修改
      if (mainTitleLinks.length > 1) {
        const newMainTitle = []
        mainTitleLinks.map((title, index) => {
          newMainTitle.push(title)
          if (index < mainTitleLinks.length - 1) {
            newMainTitle.push({ isCut: 'true', title: '•' })
          }
        })
        mainTitleLinks = newMainTitle
      }
      const mainTitleNum = mainTitleLinks.length
      return (
        <div className={styles.module_header}
          data-spm={this.props.data.spm}>
          <h2 className={styles.module_title}>
            {
              mainTitleLinks.map((mainTitle, index) => {
                if (!mainTitle) {
                  return ''
                }
                if (mainTitle.isCut) {
                  return <span className={styles.main_title_cut} key={index}>{mainTitle.title}</span>
                } else {
                  const _className = index === mainTitleNum - 1 ? classNames(styles.main_title, styles.last_item) : styles.main_title
                  return mainTitle.link
                    ? <a data-spm={mainTitle.spm}
                      key={index}
                      target='_blank'
                      className={_className}
                      href={mainTitle.link}>{mainTitle.title}</a>
                    : <span data-spm={mainTitle.spm}
                      key={index} target='_blank'
                      className={_className} >{mainTitle.title}</span>
                }
              })
            }
            <span className={styles.sub_title}>
              {
                subTitleLinks.map((subTitle, index) => {
                  if (!subTitle) {
                    return ''
                  }
                  return subTitle.link
                    ? <a key={index}
                      data-spm={subTitle.spm}
                      href={subTitle.link}
                      target='_blank'>{subTitle.title} </a>
                    : <span key={index}
                      target='_blank'>{subTitle.title} </span>
                })
              }
            </span>
            {
              subRightLinkInfo
                ? <a data-spm={subRightLinkInfo.spm}
                  className={styles.right_content}
                  target='_blank'
                  href={subRightLinkInfo.subRightLink}>
                  {subRightLinkInfo.subRightLinkTitle}
                </a> : ''
            }
            {
              changeNum ? <a className={`${styles.right_content} ${styles.change_icon}`} title={`换一换`} onClick={this.changeHandle.bind(this)}><span />换一换</a> : ''
            }
          </h2>
        </div>
      )
    }

    render () {
      let _type = this.props.data.type
      const _tabTitle = this.props.data.tabTitle
      if (_tabTitle && _tabTitle.length > 1) {
        _type = 'PC_TAB'
      }

      const isAdFocusType = _type === 'PC_ADS' && this.props.data.adType === 1
      const _containerClass = _type === 'PC_BANNER' || isAdFocusType ? '' : common.container
      const _modBottomClass = ['PC_ADS', 'PC_BANNER', 'PC_NAV'].indexOf(_type) > -1 ? '' : styles.mod_bottom
      // console.log('this.props.data', this.props.data)
      return (
        <div className={styles.mod}
          type={this.props.type}
          id={`m_${this.props.data.moduleId}`}
          name='m_pos'>
          <div className={`${_containerClass} ${_modBottomClass}`}>
            {this.renderHeader(_type)}
            {this.renderContent(_type, this.props.data)}
          </div>
        </div>
      )
    }
}
